/**
 * @param {Array} opciones - Lista de opciones a mostrar en el desplegable.
 * @param {string} campo - Nombre de la propiedad del objeto que se mostrará en la lista.
 * @param {Function} onSeleccionar - Función que se ejecuta al seleccionar una opción.
 */
import { useEffect, useState } from "react"
const DesplegableDinamico = ({ opciones, campo, onSeleccionar }) => {
  const [opcion, setOpcion] = useState([])

  useEffect(() => {
    setOpcion(opciones)
  }, [opciones])

  return (
    <div className="mb-4 bg-violet-100">
      {/* Contenedor de las opciones */}
      <div className="border rounded p-2 w-full max-h-48 overflow-auto">
        {/* Mensaje cuando no hay opciones */}
        {opcion.length === 0 ? (
          <div className="text-gray-500 text-center p-2">Escribe para buscar</div>
        ) : (
          // Renderiza las opciones disponibles
          opcion.map((item) => (
            <div
              key={item.id}
              onClick={() => onSeleccionar(item)} // Llama a la función al hacer clic
              className="cursor-pointer p-2 hover:bg-violet-400"
            >
              {item[campo]} <span className="text-gray-500">{item.descripcion}</span>
            </div>
          ))
        )}
      </div>
    </div>
  )
}

export default DesplegableDinamico

